import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex flex-col justify-center items-center text-center px-6 pt-20 pb-20 overflow-hidden" data-id="element-58">
      {/* Ultra-subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-zinc-50 rounded-full blur-3xl -z-10" data-id="element-59"></div>

      <div className="max-w-4xl mx-auto z-10" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mb-8" data-id="element-61">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full border border-zinc-200 bg-white/50 backdrop-blur-sm text-xs font-medium text-zinc-600 tracking-wide" data-id="element-62">
            Юридична практика
          </span>
        </motion.div>

        <motion.h1 className="text-5xl md:text-7xl lg:text-[80px] font-semibold tracking-tight text-zinc-900 leading-[1.05] mb-8" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: 'easeOut'
      }} data-id="element-63">
          Надійний захист <br className="hidden md:block" data-id="element-64" />
          <span className="text-zinc-400" data-id="element-65">ваших прав.</span>
        </motion.h1>

        <motion.p className="text-lg md:text-xl text-zinc-500 mb-12 max-w-2xl mx-auto leading-relaxed font-light" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-66">
          Професійна адвокатська допомога. Розробка дієвих стратегій,
          представництво в судах та вирішення складних правових питань.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-67">
          <a href="#contact" className="group flex items-center justify-center gap-2 bg-zinc-900 text-white px-8 py-4 rounded-full font-medium hover:bg-zinc-800 transition-all w-full sm:w-auto" data-id="element-68">
            Отримати консультацію
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-69" />
          </a>
          <a href="#services" className="flex items-center justify-center gap-2 bg-white text-zinc-900 border border-zinc-200 px-8 py-4 rounded-full font-medium hover:bg-zinc-50 transition-all w-full sm:w-auto" data-id="element-70">
            Сфери практики
          </a>
        </motion.div>
      </div>
    </section>;
}